import { Token } from 'typedi';

export const GA_TRACKING_ID = new Token<string>('GA_TRACKING_ID');
